export default "__VITE_ASSET__49c413bc__"